import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';

const TypoEntry = (props) => {
	const { title, chip, texts = [], options = [] } = props;

	return (
		<Stack spacing={0}>
			{(title || chip) && (
				<Stack direction="row" gap={1} alignItems="start">
					{title && <Typography variant="subtitle1">{title}</Typography>}
					{chip && <Chip size="small" variant="combined" {...chip} />}
				</Stack>
			)}
			{texts.length > 0 && (
				<Box>
					<Stack>
						{texts.map(({ id, text, isThrough, typo }) => {
							return (
								<Typography
									key={id}
									sx={{ textDecoration: isThrough ? 'line-through' : 'none' }}
									color="secondary"
									{...typo}
								>
									{text}
								</Typography>
							);
						})}
					</Stack>
				</Box>
			)}
			{options.length > 0 && (
				<Stack spacing={0.75}>
					{options.map(({ id, label, value, old }) => {
						return (
							<Box key={id}>
								{label && <Typography component="span">{label}: </Typography>}
								{value && (
									<Typography
										component="span"
										style={{ whiteSpace: 'pre-line' }}
									>
										{value}
									</Typography>
								)}
								{old && (
									<Typography
										sx={{ textDecoration: 'line-through' }}
										color="secondary"
										component="span"
										ml={0.5}
										style={{ whiteSpace: 'pre-line' }}
									>
										{old}
									</Typography>
								)}
							</Box>
						);
					})}
				</Stack>
			)}
		</Stack>
	);
};

TypoEntry.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	title: PropTypes.string,
	chip: PropTypes.shape(Chip.propTypes),
	texts: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			text: PropTypes.string,
			isThrough: PropTypes.bool,
			typo: PropTypes.shape(Typography.propTypes),
		}),
	),
	options: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			label: PropTypes.string,
			value: PropTypes.string,
			old: PropTypes.string,
		}),
	),
};

export default TypoEntry;
